import { useState } from "react";
import TrainingModal from "./TrainingModal";
const OurConsultantsSection = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalType, setModalType] = useState<'design' | 'tna'>('design');
      const handleOpenModal = (type: 'design' | 'tna') => {
        setModalType(type);
        setIsModalOpen(true);
    };
 
    return (
        <div className="container py-20">
        <div className="mb-16 space-y-3 text-center">
            <h1 className="font-semibold text-secondary sm:text-base text-sm">
                Training Solutions
            </h1>
            <h2 className="md:text-4xl sm:text-3xl text-2xl font-semibold text-primary mx-auto">
                Choose Your Training Path
            </h2>
            <p className="max-w-[764px] mx-auto sm:text-base text-sm text-gray-600">
                Select the training solution that best fits your organization's needs
            </p>
        </div>
         <div className="grid md:grid-cols-2 gap-8">
            {/* Training Design Section */}
            <div className="bg-white rounded-xl shadow-lg sm:p-8 p-4 py-8 hover:shadow-xl border border-black/15 transition-all duration-300 hover:border-secondary">
                <div className="text-center mb-6">
                    <h3 className="text-2xl font-semibold text-primary mb-4">
                        Training Design & Selection
                    </h3>
                    <p className="text-gray-600 mb-8">
                        Ready to implement specific training programs? Choose this option to design 
                        and select targeted training solutions for your workforce.
                    </p>
                    <button
                           onClick={() => handleOpenModal('design')}
                           className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-full 
                        font-medium transition-colors duration-200"
                    >
                        Start Training Design
                    </button>
                </div>
                <div className="space-y-3 text-sm text-gray-600">
                    <p className="flex items-center">
                        <span className="mr-2">✓</span>
                        Customized training programs
                    </p>
                    <p className="flex items-center">
                        <span className="mr-2">✓</span>
                        Industry-specific solutions
                    </p>
                    <p className="flex items-center">
                        <span className="mr-2">✓</span>
                        Flexible delivery options
                    </p>
                </div>
            </div>
             {/* TNA Section */}
            <div className="bg-white rounded-xl shadow-lg sm:p-8 p-4 py-8 hover:shadow-xl border border-black/15 transition-all duration-300 hover:border-secondary">
                <div className="text-center mb-6">
                    <h3 className="text-2xl font-semibold text-primary mb-4">
                        Training Needs Analysis
                    </h3>
                    <p className="text-gray-600 mb-8">
                        Not sure where to start? Let us help you identify your organization's 
                        training needs through our comprehensive analysis.
                    </p>
                    <button
                           onClick={() => handleOpenModal('tna')}
                           className="bg-green-600 hover:bg-green-700 text-white px-8 py-3 rounded-full 
                        font-medium transition-colors duration-200"
                    >
                        Start TNA Process
                    </button>
                </div>
                <div className="space-y-3 text-sm text-gray-600">
                    <p className="flex items-center">
                        <span className="mr-2">✓</span>
                        Comprehensive needs assessment
                    </p>
                    <p className="flex items-center">
                        <span className="mr-2">✓</span>
                        Data-driven recommendations
                    </p>
                    <p className="flex items-center">
                        <span className="mr-2">✓</span>
                        Strategic training roadmap
                    </p>
                </div>
            </div>
        </div>

            <TrainingModal
                isOpen={isModalOpen}
                type={modalType}
                closeModal={() => {
                    setIsModalOpen(false);
                }}
            />
        </div>
    );
};

export default OurConsultantsSection;
